import request from './../plugins/axios'

// 巡逻打卡 新增二维码
function addQRS (data) {
  return request({
    url: 'project/checkin/add',
    method: 'post',
    data
  })
}
// 巡逻打卡 列表
function QRlist (data) {
  return request({
    url: 'project/checkin/list',
    method: 'post',
    data
  })
}
// 巡逻打卡 删除
function delQR (data) {
  return request({
    url: 'project/checkin/delete',
    method: 'post',
    data
  })
}
// 巡逻打卡 编辑
function upQR (data) {
  return request({
    url: 'project/checkin/upadte',
    method: 'post',
    data
  })
}

// 执勤点列表
function checkinList (data) {
  return request({
    url: 'project/team/checkin/list',
    method: 'post',
    data
  })
}

export {
  addQRS,
  QRlist,
  delQR,
  upQR,
  checkinList
}
